import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/workpath0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Button } from 'bugu-ui';
import BuguBox from '../../src/doc-components/doc-box';
import BasicDemo from '../../src/button/demo/basic.tsx';
import SizeBtn from '../../src/button/demo/size-btn.tsx';
import LoadingButtonDemo from '../../src/button/demo/loading-btn.tsx';
import BasicDemoCode from '!raw-loader!../../src/button/demo/basic.tsx';
import SizeBtnCode from '!raw-loader!../../src/button/demo/size-btn.tsx';
import LoadingButtonDemoCode from '!raw-loader!../../src/button/demo/loading-btn.tsx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "使用说明"
    }}>{`使用说明`}</h2>
    <p>{`按钮类型：`}</p>
    <ul>
      <li parentName="ul">{`默认按钮`}</li>
      <li parentName="ul">{`主题按钮`}</li>
      <li parentName="ul">{`危险按钮`}</li>
    </ul>
    <h2 {...{
      "id": "代码演示"
    }}>{`代码演示`}</h2>
    <BuguBox code={BasicDemoCode} title="按钮类型" desc="按钮类型，包括默认类型，主题类型，危险类型。" mdxType="BuguBox">
    <BasicDemo mdxType="BasicDemo" />
    </BuguBox>
    <BuguBox code={SizeBtnCode} title="按钮尺寸" desc="设置属性size，大，中，小的值分别是large，middle，small，默认为middle。" mdxType="BuguBox">
    <SizeBtn mdxType="SizeBtn" />
    </BuguBox>
    <BuguBox code={LoadingButtonDemoCode} title="加载中" desc="loading属性为true时，Button即可处于loading状态。" mdxType="BuguBox">
    <LoadingButtonDemo mdxType="LoadingButtonDemo" />
    </BuguBox>
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`属性`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`说明`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`默认值`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`设置按钮类型`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`default `}{`|`}{` primary `}{`|`}{` danger`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`default`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`设置按钮大小`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`small   `}{`|`}{` middle  `}{`|`}{` large`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`middle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`loading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`设置按钮是否为 loading 状态`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      